import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Formik } from 'formik'
import { object as YupObject, string as YupString } from 'yup'
import { resetBackOfficeUserPassword } from '../Account/account.asyncActions'
import classNames from 'classnames'
import { selectUser } from './profile.selectors'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { isValidPassword } from '../../helpers/regex.utils'
import { isEmpty } from 'lodash'
import { useAuth0 } from '@auth0/auth0-react'
import { CardTitle } from '../../components/ui/card'

const ResetPassword = () => {
	const dispatch = useDispatch()
	const { logout } = useAuth0()

	const validationSchema = YupObject().shape({
		newPassword: YupString()
			.test(
				'validate-password',
				'Password should contain the combination of Uppercase, Lowercase, Number and Symbol',
				(val) => val && isValidPassword(val)
			)
			.required('New Password is Required')
			.min(8, 'Password must be of length more than 8'),

		confirmPassword: YupString()
			.required('Password Confirmation is Required')
			.min(8, 'Password must be of length more than 8')
			.test('passwords-match', 'Password does not match', function (value) {
				return this.parent.newPassword === value
			}),
	})
	const user = useSelector(selectUser)

	const initialValues = {
		newPassword: '',
		confirmPassword: '',
	}
	return (
		<Formik
			enableReinitialize={true}
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values, { setSubmitting, resetForm }) => {
				dispatch(
					resetBackOfficeUserPassword({
						id: user.id,
						newPassword: values.newPassword,
					})
				).then(() => {
					resetForm()
					setSubmitting(false)
					logout({ returnTo: window.location.origin })
				})
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
			}) => (
				
					<Card className='p-4' onSubmit={handleSubmit}>
						<CardTitle>Reset Password</CardTitle>
						<CardContent className='p-6 space-y-4'>
							<div className={'form-group'}>
								<Label htmlFor='newPassword'>New Password</Label>
								<Input
									id='newPassword'
									type='password'
									name='newPassword'
									value={values.newPassword}
									onChange={handleChange}
									onBlur={handleBlur}
									placeholder='New Password'
									className={classNames({ error: touched.newPassword && errors.newPassword })}
								/>
								{touched.newPassword && errors.newPassword && (
									<div className='error-message'>{errors.newPassword}</div>
								)}
							</div>
							<div className={'form-group'}>
								<Label htmlFor='confirmPassword'>Confirm New Password</Label>
								<Input
									id='confirmPassword'
									type='password'
									name='confirmPassword'
									value={values.confirmPassword}
									onChange={handleChange}
									onBlur={handleBlur}
									placeholder='Confirm Password'
									className={classNames({ error: touched.confirmPassword && errors.confirmPassword })}
								/>
								{touched.confirmPassword && errors.confirmPassword && (
									<div className='error-message'>{errors.confirmPassword}</div>
								)}
							</div>
							<Button type='button' onClick={() => handleSubmit()} disabled={!isEmpty(errors)}>
								<BusyIndicator region={REGIONS.RESET_BACKOFFICE_USER_PASSWORD}>Save</BusyIndicator>
							</Button>
						</CardContent>
					</Card>
			)}
		</Formik>
	)
}

export default ResetPassword
